// Englische Fassung von ../de/notes.ts.
import type { NotesKatalog } from "../de/notes";

export const notes: NotesKatalog = {
  // Sidebar / filter
  alleNotizen: "All notes",
  kategorien: "Categories",
  tags: "Tags",
  kategorie: "Category",
  keineKategorienHinweis: "None yet. Type @name in a note to create one.",
  filterOeffnen: "Open filter",
  filter: "Filter",
  notizenFiltern: "Filter notes",
  keineKategorienOderTags: "No categories or tags yet.",

  // List
  suchePlatzhalter: "Search notes …",
  sucheAria: "Search notes",
  neueNotiz: "New note",
  keineNotizen: "No notes yet",
  ersteNotizAnlegen: "Create your first note.",
  keineNotizAusgewaehlt: "No note selected",
  keineNotizAusgewaehltHinweis: "Pick a note on the left or create a new one.",
  leer: "(empty)",

  // Editor
  zurueckZurListe: "Back to the notes list",
  zurueck: "Back",
  wirdGespeichert: "saving …",
  gespeichertUm: (zeit: string) => `saved ${zeit}`,
  bearbeitetAm: (zeitpunkt: string) => `edited ${zeitpunkt}`,
  aufgabeVerlinkt: "Task linked",
  inAufgabeUmwandeln: "Turn into a task",
  zuAufgabeMachen: "Turn into task",
  titelPlatzhalter: "Title (optional)",
  notizTitelAria: "Note title",
  inhaltPlatzhalter: "Just start writing.",
  notizInhaltAria: "Note content",
  tagPlatzhalter: "#tag",
  tagEntfernen: (tag: string) => `Remove tag ${tag}`,
  tagHinzufuegenAria: "Add tag",
  tagHinzufuegenTitel: "Add tag",

  // Actions / feedback
  notizLoeschenFrage: "Delete note?",
  notizAngelegt: "Note created",
  notizGeloescht: "Note deleted",
  verschobenNach: (kategorie: string) => `Moved to “${kategorie}”`,
  kategorieEntfernt: "Category removed",
  kategorieNichtGeaendert: "Category not changed",
  notizInAufgabeUmgewandelt: "Note turned into a task",
  promoteFehlgeschlagen: "Could not turn the note into a task",
  konnteNichtSpeichern: "Could not save",
};
